import { UserModel } from "@/model/user/userModel";

export function ConvertToUserModel(userInfo: any): UserModel {
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
    position: userInfo.positionId,
    twoFactorAuthenticationTypeId: userInfo.twoFactorAuthenticationTypeId,
    userPINStatusId: userInfo.userPINStatusId,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
  };

  return userModel;
}
